// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderHeader_container__2b5cs"};